'use es6';

import * as api from 'laboratory-lib/core/api';
import { validateTreatmentOrKeys } from 'laboratory-lib/core/validators';
import { resolveExposures } from 'laboratory-lib/core/utils';
export function createExposureLogger({
  apiDomain,
  http,
  resolveTreatments,
  onError
}) {
  const logExposures = (treatmentOrKeys = []) => {
    try {
      validateTreatmentOrKeys(treatmentOrKeys, 'treatmentsClient.logExposure(s)');
      resolveTreatments(treatments => {
        const exposures = resolveExposures({
          treatments,
          treatmentOrKeys
        });

        if (exposures.length) {
          api.logExposures({
            apiDomain,
            exposures,
            http,
            onError
          });
        }
      });
    } catch (err) {
      if (typeof onError === 'function') {
        onError(err);
      }
    }
  };

  return {
    logExposures,
    logExposure: treatmentOrKey => logExposures([treatmentOrKey])
  };
}